interface FieldErrorShape {
  error?: string;
  fieldErrors?: Record<string, string[]>;
}

function isAuthError(error: unknown): error is FieldErrorShape {
  if (typeof error !== 'object' || error === null) return false;
  return 'error' in error || 'fieldErrors' in error;
}

export function extractErrorMessages(error: unknown): Record<string, string[]> {
  if (!isAuthError(error)) {
    if (error instanceof Error) {
      return { base: [error.message] };
    }
    return {};
  }

  if (error.fieldErrors) {
    return error.fieldErrors;
  }

  if (error.error) {
    return { base: [error.error] };
  }

  return {};
}
